import { ElementRef, Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import { SlideType } from 'projects/tools/src/public-tools';
import { Observable, from, of, timer } from 'rxjs';
import { delayWhen, map, mergeMap, switchMap, tap } from 'rxjs/operators';
// import { Orientation, SlidesGenerationOptions } from '../../dialogs/slide-export-options/slide-export-options-dialog.component';
// import { ConstantsHelper } from '../../helpers/constants-helper';
// import { ColorsHelper } from '../colors-helper';
// import { SlideItem } from '../models/slide-item';
// import { SlidesExportInterface } from './slides-export-interface';

@Injectable({
  providedIn: 'root'
})
export class PdfGenerationService2 {
  format: 'PNG' | 'JPEG' = 'JPEG';
  mimeType: 'image/png' | 'image/jpeg' = 'image/jpeg';
  jpegQuality = 0.85;
  // public exportSlide(
  //   element: HTMLElement,
  //   fileName: string,
  //   onElementLoad: (onlyLegend: boolean) => void
  // ): Observable<unknown> {
  //   onElementLoad(false);
  //   const pdf = this.createEmptyPDF();
  //   return this.addElementToPDF(pdf, element, false)
  //     .pipe(tap(() => {
  //       pdf.save(`${fileName}.pdf`);
  //     }));
  // }

  public exportSlides(
    element: HTMLElement[],
    fileName: string,
    onElementLoad: (i: number, onlyLegend: boolean) => void
  ): Observable<unknown> {
    const startTime = performance.now();
    console.log(`[PDF Export] Starting export of ${element.length} slides`);

    const pdf = this.createEmptyPDF();
    var x = pdf.internal.pageSize.height
    onElementLoad(0, false);

    const startTimeBeforeHtml2canvas = performance.now();
    console.log(`[DEBUG] Element to render:`, element[0]);

    // TYMCZASOWO pokaż element przed renderowaniem
    const originalDisplay = element[0].style.display;
    element[0].style.display = 'block';
    element[0].style.position = 'absolute';
    element[0].style.left = '-9999px'; // Przesuń poza ekran żeby nie było widoczne

    console.log(`[DEBUG] Element size after showing: ${element[0].offsetWidth}x${element[0].offsetHeight}`);

    const iframe = this.cloneElementToIframe(element[0]);
    html2canvas(iframe, {
      scale: this.getScaleFromOptions(),
      width: 1284,
      logging: true,
      useCORS: true, // Usprawnienie #3 - lepsze ładowanie obrazów
      allowTaint: false,
      imageTimeout: 0, // Nie czekaj na obrazy które się nie załadowały
      removeContainer: true
    })
    .then((canvas) => {
      // Przywróć oryginalny stan
      element[0].style.display = originalDisplay;
      element[0].style.position = '';
      element[0].style.left = '';

      const totalTimehtml2canvas = performance.now() - startTimeBeforeHtml2canvas;
      console.log(`[PDF Export] html2canvas Total time: ${(totalTimehtml2canvas / 1000).toFixed(2)}s (${totalTimehtml2canvas.toFixed(0)}ms)`);
      console.log(`[DEBUG] Canvas created: ${canvas.width}x${canvas.height}`);
    });

    const totalTimehtml2canvas = performance.now() - startTimeBeforeHtml2canvas;
    console.log(`[PDF Export] Total time: ${(totalTimehtml2canvas / 1000).toFixed(2)}s (${totalTimehtml2canvas.toFixed(0)}ms)`);

    return;
    let observable = this.addElementToPDF(pdf, element[0], 0, false);

    // TODO get full length after testing
    for (let i = 1; i < 2/*element.length*/; i++) {
      const slideIndex = i;
      observable = observable.pipe(
        tap(() => {
          console.log(`[PDF Export] Starting slide ${slideIndex + 1}/${element.length}`);
          onElementLoad(slideIndex, false);
        }),
        mergeMap((y) => this.addElementToPDF(pdf, element[slideIndex], y, false))
      );
    }

    return observable.pipe(tap(() => {
      const totalTime = performance.now() - startTime;
      console.log(`[PDF Export] Total time: ${(totalTime / 1000).toFixed(2)}s (${totalTime.toFixed(0)}ms)`);
      console.log(`[PDF Export] Average per slide: ${(totalTime / element.length).toFixed(0)}ms`);
      pdf.save(`${fileName}.pdf`);
    }));
  }

  private createEmptyPDF(): jsPDF {
    return new jsPDF('p', null, [210, 20 * 297]); //'l' : 'p'
  }

  private addCanvasToPDF(canvas: HTMLCanvasElement, pdf: jsPDF, y: number) {
    const pageWidth = 210;
    const pageHeight = 297;

    const maxImagewidth = 0.95 * pageWidth;
    // const maxImageHeight = 0.95 * pageHeight;

    let ratio = canvas.width / maxImagewidth;
    // let ratio = Math.max(canvas.width / maxImagewidth, canvas.height / maxImageHeight);

    if (ratio < 1) {
      ratio = 1;
    }

    const imgWidth = canvas.width / ratio;
    const imgHeight = canvas.height / ratio;
    const marginX = (pageWidth - imgWidth) / 2;
    const marginY = 5; //(pageHeight - maxImageHeight) / 2;

    const dataURL = canvas.toDataURL(this.mimeType, this.jpegQuality);

    pdf.addImage(dataURL, this.format, marginX, y + marginY, imgWidth, imgHeight, undefined, 'FAST');

    return y + imgHeight + marginX
  }

  private addElementToPDF(
    pdf: jsPDF,
    element: HTMLElement,
    y: number,
    addNewPage = true): Observable<number> {
    const slideStartTime = performance.now();

    if (addNewPage) {
      pdf.insertPage(pdf.getNumberOfPages() + 1);
    }

    // const isMarkdownSlide = analysisInfo.slideType === SlideType.StdTemplate || analysisInfo.slideType === SlideType.Section;
    // const isLongTimeoutNeeded = analysisInfo.slideType === SlideType.TelcoTrendsWorldMap;

    let delayTimeout = 100;
    // if (isMarkdownSlide) {
    //   // 500ms for images loading
    //   delayTimeout = 500;
    // } else if (isLongTimeoutNeeded) {
    //   // 5s for map loading due to data fetching
    //   delayTimeout = 5000;
    // }
    // const options = {
    //   margin: 10,
    //   filename: 'summary.pdf',
    //   pagebreak: { before: 'app-matrix-numerical-question' },
    //   image: { type: 'jpeg', quality: 0.98 },
    //   html2canvas: { scale: 1 },
    //   jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait', pagesplit: false },
    // };

    return of(null)
      .pipe(
        // 500ms for images loading
        tap(() => console.log(`  [Slide] Waiting ${delayTimeout}ms for images...`)),
        delayWhen(_ => timer(delayTimeout)),
        tap(() => {
          const afterDelay = performance.now();
          console.log(`  [Slide] Starting html2canvas render (${(afterDelay - slideStartTime).toFixed(0)}ms elapsed)`);
        }),
        switchMap(() => {
          const canvasStart = performance.now();
          return from(
            html2canvas(element, {
              scale: this.getScaleFromOptions(),
              width: 1284,
              logging: false,
              useCORS: true, // Usprawnienie #3 - lepsze ładowanie obrazów
              allowTaint: false,
              imageTimeout: 0, // Nie czekaj na obrazy które się nie załadowały
              removeContainer: true,
              // foreignObjectRendering: false,
              // ignoreElements: (el) => {
              //   // Ignoruj elementy które nie są w aktualnym slajdzie
              //   return !element.contains(el) && el !== element;
              // },
              // onclone: (clonedDoc) => {
              //   const cloneStart = performance.now();
              //   const elements = clonedDoc.getElementsByClassName('pdf');
              //   console.log(`  [Clone] Found ${elements.length} pdf elements to process`);

              //   for (let i = 0; i < elements.length; i++) {
              //     const element = elements[i] as HTMLElement
              //     element.style.display = 'block'; // Ustaw na widoczny tylko w klonie
              //   }

              //   const cloneTime = performance.now() - cloneStart;
              //   console.log(`  [Clone] onclone callback took ${cloneTime.toFixed(0)}ms`);
              // }
            })
          ).pipe(
            tap(() => {
              const canvasTime = performance.now() - canvasStart;
              console.log(`  [Slide] html2canvas completed in ${canvasTime.toFixed(0)}ms`);
            })
          );
        }),
        map((canvas) => {
          const pdfStart = performance.now();
          const result = this.addCanvasToPDF(canvas as HTMLCanvasElement, pdf, y);
          const pdfTime = performance.now() - pdfStart;
          const totalSlideTime = performance.now() - slideStartTime;
          console.log(`  [Slide] Added to PDF in ${pdfTime.toFixed(0)}ms`);
          console.log(`  [Slide] Total slide time: ${totalSlideTime.toFixed(0)}ms`);
          return result;
        })
      );
  }

  // private isHorizontalOrientation(orientation: Orientation) {
  //   return orientation.text === 'Horizontal';
  // }

  private getScaleFromOptions() {
    return 1; // options.imageFormat.format === 'PNG' ? 2 : 1;
  }

  private cloneElementToIframe(element: HTMLElement): HTMLIFrameElement {
    // Stwórz iframe z czystym dokumentem
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.left = '-9999px';
    iframe.style.width = '1284px';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    // Skopiuj style z głównego dokumentu
    const styles = Array.from(document.styleSheets)
      .map(sheet => {
        try {
          return Array.from(sheet.cssRules).map(rule => rule.cssText).join('\n');
        } catch (e) {
          return '';
        }
      })
      .join('\n');

    iframeDoc.open();
    iframeDoc.write(`
      <html>
        <head>
          <style>${styles}</style>
        </head>
        <body>${element.outerHTML}</body>
      </html>
    `);
    iframeDoc.close();

    return iframe;
  }
}
